import Utils from "../shared/utilerias/utils";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  BuscaCobros, FacturaMasiva } from '../entidades/entidades';
import { catchError, tap, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class FacturacionMasivaService {
    constructor(private http: HttpClient) { }


    facturam(facturaMasiva: FacturaMasiva) {

      console.log('Servicio',facturaMasiva);

      return this.http.post<any>(`${Utils.getBaseUrlApiWeb()}/FacturacionMasiva/facturam`,facturaMasiva)
        .pipe(map(res => {
          return res;
        }));
  
    }

    tareaGenerar(generaPdfs: BuscaCobros) {
      console.log('Servicio',generaPdfs);
      return this.http.post<any>(`${Utils.getBaseUrlApiWeb()}/GeneraPDFs/hilo`,generaPdfs)
        .pipe(map(res => {
          return res;
        }));
    }


}
